export function findByPath(obj, path, defaultValue, suffix) {
    var result = obj;
    for (var _i = 0, _a = path.split('.'); _i < _a.length; _i++) {
        var field = _a[_i];
        if (!result) {
            return defaultValue;
        }
        result = result[field];
    }
    return "".concat(result).concat(suffix);
}
//# sourceMappingURL=utils.js.map